export default {
  ForgotPassword: {
    RetrievalPassword: 'Lấy lại mật khẩu',
    EnterEmailOrPhoneNumberToRetrievalPassword: 'Nhập email hoặc số điện thoại để gửi yêu cầu lấy lại mật khẩu',
    EnterUserNameToRetrievalPassword: 'Nhập tên đăng nhập để gửi yêu cầu lấy lại<br/> mật khẩu',
    EnterNewPassword: 'Nhập mật khẩu mới',
    CheckInformationAndGetCode: 'Kiểm tra thông tin rồi nhấn lấy mã xác thực ',
    FullName: 'Họ tên',
    EnterStudentInfoToForgetPass: 'Nhập 1 trong 3 thông tin sau để lấy lại tài khoản:',
    ParentPhoneNumber: 'Số điện thoại<br>Phụ huynh',
    SisapCode: 'Mã SISAP',
    UserName: 'Tên đăng nhập',
    ChooseStudent: 'Chọn con',
    DescriptionChooseStudent: 'Chọn tài khoản muốn lấy lại thông tin đăng nhập',
    ChangePassword: 'Để bảo mật thông tin tài khoản, em đổi mật khẩu trong lần đăng nhập đầu tiên nhé!',
    ContactTeacherForgotPass: 'Hoặc liên hệ giáo viên chủ nhiệm của bạn<br>để lấy lại tài khoản, mật khẩu.',
    HintAccountNotFound: 'Nếu không thấy tài khoản cần lấy lại, vui lòng liên hệ giáo viên chủ nhiệm để được hỗ trợ.'
  }
}
